export class DataObject {
	public Data: string;
}

export class DataArrayObject {
	public Data: Array<string>;
}
